
<div class="rooms-container" :class='{ "rooms-container-edit": getStyleEdition }'>
  <div class="btn-multiroom-back" v-if="getSelectedRoom !== ''">
    <div class="room-name">{{ getSelectedRoomName }}</div>
    <el-button @click="unSelectRoom()" icon="el-icon-menu"></el-button>
  </div>
  <multi-rooms v-if="getSelectedRoom === ''" />
  <single-room v-if="getSelectedRoom !== ''" />
</div>
